import React, { useEffect, useState } from "react";

interface Card {
  id: number;
  value: string;
  flipped: boolean;
  matched: boolean;
}

const values = ["A", "B", "C", "D"];

const generateCards = (): Card[] => {
  const duplicated = [...values, ...values];
  const shuffled = duplicated.sort(() => Math.random() - 0.5);

  return shuffled.map((value, index) => ({
    id: index,
    value,
    flipped: false,
    matched: false,
  }));
};

const MemoryFlip = () => {
  const [cards, setCards] = useState<Card[]>(generateCards());
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [isLocked, setIsLocked] = useState(false);

  const handleClick = (id: number) => {
    if (isLocked) return;

    const card = cards.find((c) => c.id === id);
    if (!card || card.flipped || card.matched) return;

    setCards((prev) =>
      prev.map((c) =>
        c.id === id ? { ...c, flipped: true } : c
      )
    );

    setSelectedIds((prev) => [...prev, id]);
  };

  useEffect(() => {
    if (selectedIds.length !== 2) return;

    setIsLocked(true);

    const [firstId, secondId] = selectedIds;
    const firstCard = cards.find((c) => c.id === firstId);
    const secondCard = cards.find((c) => c.id === secondId);

    if (firstCard?.value === secondCard?.value) {
      // Match
      setCards((prev) =>
        prev.map((c) =>
          c.id === firstId || c.id === secondId
            ? { ...c, matched: true }
            : c
        )
      );
      setSelectedIds([]);
      setIsLocked(false);
    } else {
      // No match
      setTimeout(() => {
        setCards((prev) =>
          prev.map((c) =>
            c.id === firstId || c.id === secondId
              ? { ...c, flipped: false }
              : c
          )
        );
        setSelectedIds([]);
        setIsLocked(false);
      }, 900);
    }
  }, [selectedIds]);

  const handleReset = () => {
    setCards(generateCards());
    setSelectedIds([]);
    setIsLocked(false);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="grid grid-cols-4 gap-4">
        {cards.map((card) => (
          <button
            key={card.id}
            onClick={() => handleClick(card.id)}
            className={`
              w-20 h-20 rounded-xl text-xl font-semibold
              transition-all duration-300
              ${
                card.flipped || card.matched
                  ? "bg-gradient-to-br from-orange-400 to-orange-500 text-white shadow-lg shadow-orange-300/40"
                  : "bg-white border border-orange-200 hover:bg-orange-50"
              }
            `}
          >
            {card.flipped || card.matched ? card.value : "?"}
          </button>
        ))}
      </div>

      <button
        onClick={handleReset}
        className="mt-6 px-4 py-2 bg-orange-100 text-orange-700 rounded-lg hover:bg-orange-200 transition"
      >
        Reset
      </button>
    </div>
  );
};

export default MemoryFlip;